import Case3 from './Case3'

export default Case3
